import { render, staticRenderFns } from "./GrupoBarniz.vue?vue&type=template&id=478995ed&"
import script from "./GrupoBarniz.vue?vue&type=script&lang=js&"
export * from "./GrupoBarniz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports